import { config } from './main.js';

export {
    dirToRad,
    degToRad,
}

// Convert world direction to radians
function dirToRad(dir) {
    return dir * Math.PI / 180 - Math.PI/2;
}

// Convert degrees to radians
function degToRad(deg) {
    return deg * Math.PI / 180;
}
